'use client'

import { Button } from '@/components/ui/button'
import { motion } from 'framer-motion'
import React from 'react'

interface AllServicesHeroSectionProps {
  title: string
  description: string
  buttonText?: string
}

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6 },
  },
}

const AllServicesHeroSection: React.FC<AllServicesHeroSectionProps> = ({
  title,
  description,
  buttonText,
}) => {
  return (
    <section className="relative pt-24 pb-12 sm:pt-20 sm:pb-16 lg:py-20 overflow-hidden">
      {/* Background gradients & pattern */}
      <div className="absolute inset-0 bg-gradient-to-r from-emerald-50 to-teal-50 opacity-70" />
      <div className="absolute right-0 top-0 w-1/2 h-full">
        <div className="absolute inset-0 bg-gradient-to-l from-emerald-100 to-transparent" />
        <div className="absolute inset-0 opacity-20">
          <svg viewBox="0 0 400 400" className="w-full h-full">
            <defs>
              <pattern
                id="pattern-circles"
                x="0"
                y="0"
                width="50"
                height="50"
                patternUnits="userSpaceOnUse"
                patternContentUnits="userSpaceOnUse"
              >
                <circle
                  id="pattern-circle"
                  cx="10"
                  cy="10"
                  r="1.6257413380501518"
                  fill="#4ade80"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#pattern-circles)" />
          </svg>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <motion.div
          className="max-w-3xl"
          initial="hidden"
          animate="visible"
          variants={fadeIn}
        >
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-serif text-gray-900 mb-4 sm:mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-6 sm:mb-8 leading-relaxed">
            {description}
          </p>
          {buttonText && (
            <Button
              className="bg-emerald-500 hover:bg-emerald-600 text-white px-6 py-2.5 sm:px-8 sm:py-3 rounded-full text-base sm:text-lg transition-transform duration-300 hover:scale-105"
              onClick={() =>
                document
                  .getElementById('collaborative-approach')
                  ?.scrollIntoView({ behavior: 'smooth' })
              }
            >
              {buttonText}
            </Button>
          )}
        </motion.div>
      </div>
    </section>
  )
}

export default AllServicesHeroSection
